import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { httpOptions } from 'src/app/global/global_variables';
import { TimeTableInterface } from 'src/app/models/TimeTableModel';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { TimetableService } from 'src/app/services/timetable/timetable.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-time-table',
  templateUrl: './time-table.component.html',
  styleUrls: ['./time-table.component.css'],
})
export class TimeTableComponent {
  @Input() toggle: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();
  letUserEdit: boolean = false;
  data: TimeTableInterface[] = [];
  tripToEdit!: TimeTableInterface | null

  showForm: boolean = false

  faTrash = faTrash
  faPen = faPen
  faPlus = faPlus

  ngOnInit() {
    this.loadTimeTable()
  }

  constructor(private http: HttpClient, private timeTableService: TimetableService) {

  }
  onToggleClick() {
    this.toggleChange.emit(false);
  }

  toggleForm() {
    this.showForm = !this.showForm
    if(!this.showForm){
      this.tripToEdit = null
    }
  }

  loadTimeTable() {
    this.http.get<any>(`${environment.apiLink}/TimeTable/GetTimeTable`, httpOptions).subscribe((resp) => {
      const response = resp.timeTable as TimeTableInterface[]
      this.data = response
    })
  }

  deleteTripById(tripId: number) {
    if (confirm(`Deseja realmente excluir a viagem ${tripId}?`)) {
      this.timeTableService.deleteTrip(tripId).subscribe({
        next: () => {
          alert("Viagem excluída com sucesso");
          // Atualize a lista localmente removendo o item excluído
          this.data = this.data.filter(viagem => viagem.viagem !== tripId);
        },
        error: (err) => {
          console.error("Erro ao excluir viagem:", err);
          alert("Erro ao excluir a viagem");
        },
      });
    }
  }

  openEditForm(trip: TimeTableInterface) {
    this.showForm = true
    this.tripToEdit = trip
  }

  onDataUpdated() {
    this.loadTimeTable()
    this.showForm = false
  }

  //* -------------------------------------------- FORMATAÇÃO DE NÚMEROS -------------------------------------------- *//
  calculateDifference(start: string, end: string): string {
    const endTime = this.convertTimeStringToValidDate(end);
    const startTime = this.convertTimeStringToValidDate(start);

    if (!startTime || !endTime) return " "

    if (endTime.getTime() < startTime.getTime()) {
      // Adiciona 24 horas ao endTime se ele for menor que startTime
      endTime.setDate(endTime.getDate() + 1);
    }

    const diffInMs = endTime.getTime() - startTime.getTime();

    const diffInHours = Math.floor(diffInMs / (60 * 60 * 1000));
    const diffInMinutes = Math.floor((diffInMs % (60 * 60 * 1000)) / (60 * 1000));

    const formattedHours = String(diffInHours).padStart(2, '0');
    const formattedMinutes = String(diffInMinutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  convertTimeStringToValidDate(timeString: string) {
    if (!timeString) return null;

    const currentDate = new Date();
    const [hours, minutes] = timeString.split(":").map(Number)
    currentDate.setHours(hours)
    currentDate.setMinutes(minutes)
    currentDate.setSeconds(0)
    currentDate.setMilliseconds(0)
    return currentDate
  }

}
